  (function () {
    var root = document.querySelector('[data-hr-hs]');
    if (!root) return;
    var track = root.querySelector('[data-hr-hs-track]');
    var chrome = root.querySelector('[data-hr-hs-chrome]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hr-hs-slide]'));

    // Entrance emphasis runs whether or not there is a second slide, so a
    // one-slide hero still gets its headline highlight.
    if (slides[0]) window.setTimeout(function () { slides[0].classList.add('is-entered'); }, 380);

    // PERF FIX 2026-08-08: warm every non-first slide's real photo off the
    // critical path, but well inside the one-shot autoplay's 3.5s budget.
    // See the Liquid capture-and-replace comment above .hr-hs__media for the full
    // rationale (native loading="lazy" was not actually deferring these on
    // WebKit in this horizontally-scrolling layout). data-src/data-srcset
    // swap order matters for <picture>: every <source>'s srcset must be
    // updated BEFORE the <img>'s src/srcset, because the browser only
    // re-runs picture source selection when the <img> element's own
    // src/srcset changes -- updating a <source> alone does not trigger a
    // re-fetch. decode() is called (and awaited, non-blocking) so a slide
    // only counts as "warmed" once it is actually paint-ready, not merely
    // requested.
    // 2026-08-08: extended for the harvest slide's composed pouch/berry
    // cloud and its berry-mass equation image -- plain <img data-src>
    // elements that live OUTSIDE a <picture> (the earlier version of this
    // function returned early when no <picture> existed, which is exactly
    // this slide's shape). No <source> re-selection is needed for a bare
    // <img>: it re-fetches the instant its own src/srcset changes, so this
    // path is simpler than the <picture> path above. Runs for every slide
    // regardless of whether it also has a <picture>, so both shapes are
    // warmed by one call.
    function warmSlide(slideEl) {
      if (!slideEl || slideEl.hasAttribute('data-hr-hs-warmed')) return;
      slideEl.setAttribute('data-hr-hs-warmed', '');
      var picture = slideEl.querySelector('picture');
      if (picture) {
        var sources = Array.prototype.slice.call(picture.querySelectorAll('source[data-srcset]'));
        sources.forEach(function (s) {
          s.setAttribute('srcset', s.getAttribute('data-srcset'));
          s.removeAttribute('data-srcset');
        });
        var pictureImg = picture.querySelector('img[data-src]');
        if (pictureImg) {
          if (pictureImg.hasAttribute('data-srcset')) {
            pictureImg.setAttribute('srcset', pictureImg.getAttribute('data-srcset'));
            pictureImg.removeAttribute('data-srcset');
          }
          pictureImg.setAttribute('src', pictureImg.getAttribute('data-src'));
          pictureImg.removeAttribute('data-src');
          if (typeof pictureImg.decode === 'function') { pictureImg.decode().catch(function () {}); }
        }
      }
      var plainImgs = Array.prototype.slice.call(slideEl.querySelectorAll('img[data-src]'));
      plainImgs.forEach(function (img) {
        if (img.hasAttribute('data-srcset')) {
          img.setAttribute('srcset', img.getAttribute('data-srcset'));
          img.removeAttribute('data-srcset');
        }
        img.setAttribute('src', img.getAttribute('data-src'));
        img.removeAttribute('data-src');
        if (typeof img.decode === 'function') { img.decode().catch(function () {}); }
      });
    }
    function warmNonFirstSlides() {
      slides.forEach(function (s, si) { if (si !== 0) warmSlide(s); });
    }
    /* 2026-08-09 (owner): "when I scroll to the second one manually, the box
       loads so slow, it is a weird interaction there."
       Cause: the non-first slides were only warmed on browser idle with a
       1200ms timeout, so a visitor who swiped within the first second or so
       arrived at slide 2 before its composed box photo had even been
       REQUESTED, and watched it appear. Two changes: the idle deadline drops
       to 400ms, and any touch on the hero warms the remaining slides
       immediately, because a finger on the hero is the strongest possible
       signal that another slide is about to be needed. Slide 1 is still never
       in this set, so the LCP image keeps the critical path to itself. */
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmNonFirstSlides, { timeout: 400 });
    } else {
      window.setTimeout(warmNonFirstSlides, 250);
    }
    // Belt-and-suspenders: any real interaction with the hero warms
    // everything immediately, so a visitor who swipes fast never outruns
    // the idle-callback timer.
    root.addEventListener('touchstart', warmNonFirstSlides, { passive: true, once: true });
    root.addEventListener('pointerdown', warmNonFirstSlides, { passive: true, once: true });

    if (!chrome) return; // single slide: chrome doesn't exist, nothing to wire up

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hr-hs-dot]'));
    var prevBtn = root.querySelector('[data-hr-hs-prev]');
    var nextBtn = root.querySelector('[data-hr-hs-next]');
    var count = slides.length;
    var index = 0;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function syncDots() {
      dots.forEach(function (d, di) { d.setAttribute('aria-current', di === index ? 'true' : 'false'); });
      // Emphasis highlight replays each time a slide becomes the current one,
      // and is cleared on the way out so it always reads as an entrance.
      slides.forEach(function (s, si) { s.classList.toggle('is-entered', si === index); });
    }

    function goTo(i) {
      index = (i + count) % count;
      var target = slides[index];
      if (reduce.matches) {
        // Reduced motion: never travel the viewport. Cross-fade the track,
        // jump instantly while it is invisible, fade back. Same information,
        // zero movement.
        track.style.transition = 'opacity 170ms linear';
        track.style.opacity = '0';
        window.setTimeout(function () {
          track.scrollTo({ left: target.offsetLeft, behavior: 'auto' });
          track.style.opacity = '1';
        }, 170);
      } else {
        // Smooth scroll is natively interruptible: a touch on the track takes
        // the scroll over mid-flight, so an auto-advance can never fight the
        // user's finger.
        track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
      syncDots();
      schedule();
    }

    /* ===== Autoplay (owner 2026-08-08: 10s dwell across all 3 slides) =====
       Rules, per apple-design:
       - never yank mid-read: DWELL_MS defines the interval, and the transition itself is the
         interruptible smooth scroll above (reduced motion gets a crossfade);
       - pause while the user is touching, dragging, hovering, or keyboard-
         focused inside the hero, and while the tab is hidden;
       - any manual navigation (arrow, dot, swipe) RESETS the full dwell rather
         than letting a queued advance fire a moment later. */
    /* Owner 2026-07-30: the hero auto-advances ONCE, from the first slide to the
       second, about 3.5s after load, then stays put. It is not a loop. After that
       single move (or the instant the visitor touches or navigates the hero),
       autoplay is finished and the visitor is fully in control, both directions.
       The section's autoplay setting now only acts as an on/off (0 = off). */
    /* 2026-08-09 (owner): "why don't the hero headers auto-scroll by themselves,
       they should change by themselves ... these are three screens, they should
       auto-slide by themselves after 10 seconds."
       This REVERSES the 2026-07-30 directive that made the hero a ONE-SHOT: it
       advanced once from slide 1 to slide 2 after 3.5s and then stopped forever,
       which is why slides 2 and 3 never appeared on their own. It is now a
       continuous 10-second carousel across all three slides.
       Everything that should still pause it is unchanged: a finger on the hero,
       hover on a real pointer, keyboard focus inside it, and a hidden tab. The
       difference is that those now PAUSE and resume rather than killing autoplay
       for the rest of the pageview, and any manual navigation simply restarts
       the full 10s dwell (goTo calls schedule) instead of ending the carousel.
       Reduced motion switches it off entirely: someone who has asked the OS to
       stop motion should not get a self-moving hero. */
    /* 2026-08-11 (owner): "the scroll effect is too fast from the hero image to
       the second one. It should STAY on the second one and not move, and let the
       user slide to the next one, that's it. The slide only happens once for the
       user unless the user has refreshed the page. Up the time so it takes a
       little longer to scroll to the second slide, so it gives the second image
       time to load all the content there."

       This RESTORES THE ONE-SHOT and reverses the 2026-08-09 continuous
       carousel. The hero now makes exactly ONE automatic move per pageview,
       slide 1 to slide 2, after DWELL_MS. It never advances to slide 3 on its
       own and never loops -- slide 3 is the visitor's to reach.

       "Once per pageview" is deliberately a plain variable, not sessionStorage:
       the owner's rule is that a refresh earns the animation again, which is
       exactly what a per-load variable gives for free.

       DWELL_MS was 1500, set on 2026-08-09 when the complaint was the opposite
       (10s felt dead). At 1.5s the move lands before slide 2 has painted, which
       is the current complaint. 4s reads deliberate rather than twitchy and
       gives slide 2 a real preload budget. 2026-08-11 (owner, second cut): he
       named 2.5s exactly, so that is the number. warmNonFirstSlides runs at
       ~250ms, leaving slide 2 ~2.25s of headroom before it is on screen. */
    var autoplayEnabled = (parseFloat(root.getAttribute('data-hr-hs-autoplay')) || 0) !== 0 && !reduce.matches;
    /* OWNER 2026-08-21: "it slides away too quickly... I can't even read what it
       says, I have to go back." 2500ms was still too short once the horse
       animation eats the first beat of attention. +1.5s per his ask. */
    var DWELL_MS = 4000;
    var autoAdvancesLeft = 1;   // ONE automatic move per pageview. A refresh re-arms it.
    var timer = null;
    var pauses = 0;          // >0 means something is holding autoplay

    function clearTimer() { if (timer) { window.clearTimeout(timer); timer = null; } }

    /* Any manual navigation ENDS autoplay for the rest of the pageview. Once the
       visitor has taken control the hero must never move under them again. */
    function cancelAutoplay() { autoAdvancesLeft = 0; clearTimer(); }

    function schedule() {
      clearTimer();
      if (!autoplayEnabled || autoAdvancesLeft < 1 || count < 2 || pauses > 0 || document.hidden) return;
      timer = window.setTimeout(function () {
        timer = null;
        if (pauses > 0 || document.hidden) return;
        /* Spend the budget BEFORE moving. goTo() ends with schedule(), so
           consuming it first is what makes that call a no-op and stops this
           quietly becoming a loop again. */
        autoAdvancesLeft = 0;
        goTo(index + 1);
      }, DWELL_MS);
    }

    function hold() { pauses++; clearTimer(); }
    function release() { pauses = Math.max(0, pauses - 1); if (pauses === 0) schedule(); }

    // Touch / pointer: hold for the duration of the gesture only.
    var gestureHeld = false;
    function gestureStart() {
      warmNonFirstSlides();   /* a finger on the hero means another slide is imminent */
      cancelAutoplay();
      if (!gestureHeld) { gestureHeld = true; hold(); }
    }
    function gestureEnd() { if (gestureHeld) { gestureHeld = false; release(); } }
    root.addEventListener('pointerdown', gestureStart, { passive: true });
    root.addEventListener('touchstart', gestureStart, { passive: true });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (ev) {
      window.addEventListener(ev, gestureEnd, { passive: true });
    });

    // Hover only where hovering is a real thing.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var hoverHeld = false;
      root.addEventListener('mouseenter', function () { if (!hoverHeld) { hoverHeld = true; hold(); } });
      root.addEventListener('mouseleave', function () { if (hoverHeld) { hoverHeld = false; release(); } });
    }

    // Keyboard focus inside the hero: don't move the thing being read/tabbed.
    var focusHeld = false;
    root.addEventListener('focusin', function () { if (!focusHeld) { focusHeld = true; hold(); } });
    root.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (focusHeld && !root.contains(document.activeElement)) { focusHeld = false; release(); }
      }, 0);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearTimer(); else schedule();
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { cancelAutoplay(); goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { cancelAutoplay(); goTo(index + 1); });
    dots.forEach(function (d, di) { d.addEventListener('click', function () { cancelAutoplay(); goTo(di); }); });

    // keep dots in sync with native swipe/scroll (transform/opacity only visuals; this just tracks index)
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var closest = 0, min = Infinity;
        slides.forEach(function (s, si) {
          var d = Math.abs(s.offsetLeft - track.scrollLeft);
          if (d < min) { min = d; closest = si; }
        });
        index = closest;
        syncDots();
        // 2026-08-09: this used to end the one-shot for good once the visitor
        // settled on any slide but the first. The hero is a continuous 10s
        // carousel now, so settling simply restarts the dwell on whichever
        // slide they landed on.
        schedule();
      }, 100);
    }, { passive: true });

    // First paint: let the hero settle, then run the entrance highlight on the
    // slide the visitor is actually looking at.
    schedule();
  })();
  (function () {
    // Header-seam fix: measure the floating header's real rendered height and
    // publish it as --hr-header-h on the root, so the hero (see .hr-hs
    // margin-top above) can pull itself up by exactly that amount and the
    // photo runs full-bleed to y=0 behind the header pill, instead of a flat
    // fill color trying (and failing) to match the photo's top-edge gradient.
    //
    // Bug found 2026-07-29: this theme renders the section wrapper with a
    // dynamic id (shopify-section-sections--<hash>__header), not the classic
    // static "shopify-section-header" / ".shopify-section-header" this
    // selector was written for -- so those two branches never match anything
    // here, and the query fell through to `sticky-header`, the INNER pill
    // element, which is ~24px SHORTER than the outer section wrapper that
    // actually reserves the flow space (the wrapper has its own top/bottom
    // padding around the pill). The hero was therefore always pulled up
    // ~24px short of true y=0, leaving a residual sliver at the very top
    // that showed the flat html/body sky-gradient fallback (see the
    // "HEADER SEAM FIX" block below) instead of the slide's own photo --
    // reproducible on every load, not a race condition. Fix: find the
    // sticky-header element (works regardless of id/class naming) and walk
    // up to its own Shopify section wrapper, whose rendered height is the
    // true reserved space.
    var stickyEl = document.querySelector('sticky-header, #shopify-section-header, .shopify-section-header');
    if (!stickyEl) return;
    var header = stickyEl.closest('[id^="shopify-section-"]') || stickyEl;
    var root = document.documentElement;

    var hero = document.querySelector('[data-hr-hs]');

    // CLS FIX (owner-reported "resizes by itself" glitch, verified via Playwright):
    // the CSS fallbacks above now default to 84px (the header's own reserved
    // min-height, see sections/header.liquid), matching the common no-announcement-bar
    // case on FIRST paint, so this script only needs to correct drift, never
    // establish the layout from scratch. Skip the DOM write entirely when the
    // measured value has not meaningfully changed (<=1px, e.g. subpixel/font-swap
    // noise) so a visually-identical remeasure never triggers a reflow the visitor
    // can see.
    var lastHeaderH = null;
    var lastHsTop = null;
    function measure() {
      var h = header.getBoundingClientRect().height;
      if (h > 0 && (lastHeaderH === null || Math.abs(h - lastHeaderH) > 1)) {
        lastHeaderH = h;
        root.style.setProperty('--hr-header-h', h + 'px');
      }
      // Anything above the hero that is NOT the floating header (the
      // announcement bar) still pushes the section down the page. Publish it
      // so the mobile slide can be exactly one viewport tall and keep its dots
      // above the fold.
      //
      // Bug found 2026-07-29: on first paint, a full-viewport page loader
      // (#hrloader, first child of body) can still be occupying real flow
      // space at the exact moment this synchronous measure() runs, which
      // pushes hero.getBoundingClientRect().top to ~100vh for that one
      // reading -- and since .hr-hs__slide's mobile height is `100svh minus
      // this value`, that single bad reading collapsed the whole hero to 0
      // height (verified live: --hr-hs-top published as 844px on a 390x844
      // phone). None of the existing re-measure triggers (resize,
      // orientationchange, fonts.ready) reliably fire again after the loader
      // hides itself, so the stale 844px value could stick. Fixed two ways:
      // a sane ceiling here (the announcement bar this variable actually
      // exists for is never anywhere near this tall, so anything bigger is
      // treated as a transient artifact, not real content), and a `load`
      // listener that re-measures once the whole page -- loader included --
      // has settled. `.hr-hs__slide` also keeps a min-height floor (see the
      // mobile media query above) as a hard backstop against any future
      // instance of the same class of bug.
      if (hero) {
        // PERF FIX 2026-08-08: was `hero.getBoundingClientRect().top`, which
        // reads the hero's position AFTER its own negative margin-top
        // (`.hr-hs { margin-top: calc(-1 * var(--hr-header-h)) }`) has been
        // applied -- so this reading was entangled with two other pieces of
        // async/racy state (that margin depending on --hr-header-h having
        // already been written above, AND #hrloader's fixed positioning
        // having already applied, see snippets/hr-page-loader.liquid).
        // `header` (the sticky header group, a plain in-flow element with no
        // such trick) tells us the same thing directly and robustly: its own
        // top IS exactly how much real content precedes it. In the common
        // case (no announcement bar) that is 0, with no dependency on the
        // hero's own CSS or on any other element's load timing.
        var top = header.getBoundingClientRect().top + (window.pageYOffset || 0);
        var safeTop = Math.max(0, Math.min(240, Math.round(top)));
        if (lastHsTop === null || Math.abs(safeTop - lastHsTop) > 1) {
          lastHsTop = safeTop;
          root.style.setProperty('--hr-hs-top', safeTop + 'px');
        }
      }
    }

    // OWNER FIX 2026-07-31 (reported TWICE: "the hero image of the girl holding the
    // pouch is still auto-resizing by itself... it appears then resizes"). Root cause,
    // found by measuring, not guessing: --hr-hs-top and --hr-header-h are LAYOUT-
    // AFFECTING custom properties (they drive .hr-hs__slide's height and
    // .hr-hs__content's padding directly). The previous build re-ran measure() on the
    // window 'load' event and on document.fonts.ready -- both of which fire AFTER the
    // hero photo is already visible on screen, so any correction they made was a
    // visible post-paint jump: exactly "appears, then resizes". A prior fix attempt
    // only changed a CSS fallback (84px) and touched the wrong file; it could not have
    // fixed this because the bug is the JS re-measuring after paint, not the fallback
    // value.
    // Fix: measure synchronously (unchanged), then take ONE more correction on the
    // next two animation frames (double rAF finishes inside ~32ms, well before any
    // photo has actually downloaded, so it is invisible) to catch anything not fully
    // settled at parse time -- e.g. the header's own async bits. After that, only
    // 'resize' and 'orientationchange' re-measure: real viewport changes a visitor
    // causes themselves, which are expected to reflow. 'load' and fonts.ready are
    // deliberately NOT wired to this anymore -- both fire only once the hero photo
    // (often the largest asset on the page) has actually finished downloading and is
    // already visible, which is precisely what made the correction look like the
    // photo "appears, then resizes".
    // PERF/CLS FIX (Lighthouse mobile audit, CLS score 1.0 -- worst possible):
    // the double-rAF re-measure below ran AFTER first paint (this script tag
    // executes synchronously during parse, but the rAF callbacks fire on the
    // next two animation frames, which land after the browser has already
    // painted the hero at the CSS fallback values). On a throttled mobile
    // run, web-font swap between the synchronous measure() and that first
    // paint could nudge the header's real height by a few px, and the
    // corrected write to --hr-header-h / --hr-hs-top after paint counted as
    // a full-viewport layout shift (the hero's height/padding both derive
    // from these vars). The CSS fallbacks (84px) already match the header's
    // real reserved min-height (see sections/header.liquid line 56), so the
    // single synchronous measure() call below already gets it right before
    // anything paints -- the rAF "catch anything not settled" pass bought
    // negligible accuracy for a guaranteed-visible-to-Lighthouse shift, so
    // it is removed. Only real viewport changes (resize/orientationchange)
    // still re-measure, which are expected reflows, not initial-load CLS.
    measure();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('orientationchange', measure, { passive: true });
  })();
  (function () {
    // Wild-harvested slide (3): the real berry-fall <video> only ever plays
    // when this slide is BOTH the active/current slide AND the hero is
    // on-screen, and pauses instantly when the tab goes to the background --
    // reusing the theme's shared HRPerf visibility system
    // (assets/hr-perf-core.js) instead of a new always-on rAF/interval.
    // A MutationObserver (event-driven, not polling) tracks the slider's own
    // `is-entered` class, which the slider script already toggles on slide
    // change. Under prefers-reduced-motion the video is never played at all
    // -- the poster (the front-facing hands photo) is the permanent state,
    // matching the CSS fallback above.
    // 2026-08-05: the source clip is now a genuinely seamless crossfade loop,
    // so ONE element with native `loop` is correct. The previous two-video
    // A/B swap (plus its glow/settle pulse fired on the fake loop point) is
    // gone -- it was adding a second, visible restart on top of a loop that
    // already has none, which is exactly what the owner saw as "I can see the
    // video already ended, there is no loop".
    var harvestSlide = document.querySelector('.hr-hs__slide--harvest');
    if (!harvestSlide) return;
    // 2026-08-06: the berry-fall is a CODE animation now, not a video, so this
    // gate toggles ONE class instead of driving play()/pause(). The CSS keeps
    // every berry at `animation-play-state: paused` until `.is-berryfall-live`
    // lands on the hero root. Same three conditions as before (section on
    // screen AND this slide active AND tab visible) -- the win is that a paused
    // CSS animation costs literally nothing, whereas a paused <video> still
    // held a decoded frame buffer.
    var berryfall = harvestSlide.querySelector('[data-hr-hs-berryfall]');
    if (!berryfall) return;

    var heroRoot = document.querySelector('[data-hr-hs]');
    if (!heroRoot) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // CSS already hides the berries entirely; never add the live class.
      return;
    }

    var sectionVisible = false;
    var slideActive = harvestSlide.classList.contains('is-entered');

    function sync() {
      heroRoot.classList.toggle('is-berryfall-live', !!(sectionVisible && slideActive));
    }

    if (heroRoot && window.HRPerf && typeof window.HRPerf.onVisible === 'function') {
      window.HRPerf.onVisible(heroRoot, function (isVisible) {
        sectionVisible = isVisible;
        sync();
      });
    } else if (typeof IntersectionObserver === 'function' && heroRoot) {
      var io = new IntersectionObserver(function (entries) {
        sectionVisible = entries[0] && entries[0].isIntersecting;
        sync();
      }, { threshold: 0 });
      io.observe(heroRoot);
    } else {
      sectionVisible = true; // no IO support: behave as always-visible, matches the rest of the theme's fallback
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { heroRoot.classList.remove('is-berryfall-live'); }
      else sync();
    });

    var mo = new MutationObserver(function () {
      var active = harvestSlide.classList.contains('is-entered');
      if (active !== slideActive) {
        slideActive = active;
        sync();
      }
    });
    mo.observe(harvestSlide, { attributes: true, attributeFilter: ['class'] });

    sync();
  })();
